module.exports = __webpack_public_path__ + "static/media/field-detection.74620d7a.svg";